import { useRequestOauthRevoke } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useAuthContext } from "src/contexts/AuthContext"
import { useSessionStorageContext } from "src/contexts/SessionStorageContext"
import type { RoutePath } from "src/types"
import { noticeError } from "src/utils"

export interface SignOutParams {
  loginRedirect?: RoutePath;
  logoutRedirect?: RoutePath;
}

const clientId: string = process.env.REACT_APP_SUGARMATE_OAUTH_CLIENT_ID ?? ""

export function useSignOut() {
  const {
    clearAuthCookie,
    authCookieRef,
  } = useAuthContext()

  const {
    setLoginRedirect,
    setLogoutRedirect,
  } = useSessionStorageContext()

  const requestOauthRevoke = useRequestOauthRevoke()

  return useMemo(
    () => !requestOauthRevoke
      ? undefined
      : async (params: SignOutParams = {}) => {
        const {
          loginRedirect,
          logoutRedirect,
        } = params

        setLoginRedirect(loginRedirect)
        setLogoutRedirect(logoutRedirect)

        try {
          await requestOauthRevoke({
            client_id: clientId,
            token: authCookieRef.current?.access_token ?? "",
          })
        } catch (e) {
          noticeError(
            e,
            "SignOut",
          )
        }

        clearAuthCookie()
      },
    [
      setLoginRedirect,
      setLogoutRedirect,
      clearAuthCookie,
      authCookieRef,
      requestOauthRevoke,
    ],
  )
}
